export { default } from './ProfilePrimaryMode';
